import { getClusterings } from '@/api/sales/clustering';
import { getDistributionChannels } from '@/api/sales/distributionChannel';
import { getPosTypes } from '@/api/sales/posType';
import { getDeliveryLocationGroups } from '@/api/sales/deliveryLocationGroup';
import { getDeliveryLocationSeasonalities } from '@/api/sales/deliveryLocationSeasonality';

export async function buildDeliveryLocationAttributeMaps() {
	const [clusteringsList, distributionChannelsList, posTypesList, locationGroupsList, seasonalitiesList] = await Promise.all([getClusterings().catch(() => []), getDistributionChannels().catch(() => []), getPosTypes().catch(() => []), getDeliveryLocationGroups().catch(() => []), getDeliveryLocationSeasonalities().catch(() => [])]);

	return {
		clusteringById: new Map((Array.isArray(clusteringsList) ? clusteringsList : []).map((c) => [c.id, c])),
		distributionChannelById: new Map((Array.isArray(distributionChannelsList) ? distributionChannelsList : []).map((c) => [c.id, c])),
		posTypeById: new Map((Array.isArray(posTypesList) ? posTypesList : []).map((c) => [c.id, c])),
		locationGroupById: new Map((Array.isArray(locationGroupsList) ? locationGroupsList : []).map((c) => [c.id, c])),
		seasonalityById: new Map((Array.isArray(seasonalitiesList) ? seasonalitiesList : []).map((c) => [c.id, c])),
	};
}

export function resolveDeliveryLocationAttributes(deliveryLocation, { clusteringById, distributionChannelById, posTypeById, locationGroupById, seasonalityById }) {
	const clusteringItem = clusteringById.get(deliveryLocation.clusterId);
	const distributionChannelItem = distributionChannelById.get(deliveryLocation.distributionChannel);
	const posTypeItem = posTypeById.get(deliveryLocation.posTypeId);
	const locationGroupItem = locationGroupById.get(deliveryLocation.groupId);
	const seasonalityNames = Array.isArray(deliveryLocation.seasonalities)
		? deliveryLocation.seasonalities
				.map((id) => seasonalityById.get(id))
				.filter(Boolean)
				.map((s) => s.name || s.label || '')
				.filter(Boolean)
				.join(', ')
		: '';

	return {
		clusterId: deliveryLocation.clusterId ?? null,
		posType: posTypeItem?.name || posTypeItem?.label || '',
		cluster: clusteringItem?.name || clusteringItem?.label || '',
		locationGroup: locationGroupItem?.name || locationGroupItem?.label || '',
		distributionChannel: distributionChannelItem?.name || distributionChannelItem?.label || '',
		potential: deliveryLocation.potentialVal ?? null,
		seasonality: seasonalityNames,
	};
}
